import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";
import { getSessionId } from "./authService";

const PUBLIC_SITE_PRICING_SETTINGS_PATH = "/api/agents/me/public-site-pricing-settings";

function publicSitePricingSettingsUrl() {
  return resolveApiUrl(PUBLIC_SITE_PRICING_SETTINGS_PATH);
}

async function withSessionRequestConfig() {
  const sessionID = await getSessionId();
  if (!sessionID) {
    throw new Error("public_site_pricing_settings_no_session");
  }
  const sid = String(sessionID).trim();
  return {
    headers: {
      "Content-Type": "application/json",
      "X-Session-ID": sid,
    },
    withCredentials: true,
    timeout: 20000,
    sid,
  };
}

export async function fetchPublicSitePricingSettings() {
  const cfg = await withSessionRequestConfig();
  const { data } = await axios.get(publicSitePricingSettingsUrl(), cfg);
  return data;
}

export async function savePublicSitePricingSettings(payload) {
  const cfg = await withSessionRequestConfig();
  const body = {
    hotel: payload?.hotel,
    flight: payload?.flight,
    vacation_package: payload?.vacation_package,
    sessionID: cfg.sid,
  };
  const { data } = await axios.patch(publicSitePricingSettingsUrl(), body, cfg);
  return data;
}
